import React from 'react'
import { Menu } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

// import logo from '../images/logo.png'

class Navbar extends React.Component {
  state = { activeItem: 'home' }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  render() {
    const { activeItem } = this.state
    return (
      <Menu stackable>
        <Menu.Item 
          name='home'
          active={activeItem === 'home'}
          onClick={this.handleItemClick}
          >
          <NavLink to='/'>
            <img className='navbar-logo' src={"https://videos.virtualapt.com/thumbnails/logo.png"} alt="VirtualAPT Logo" />
          </NavLink>
        </Menu.Item>
        <Menu.Item
          name='best'
          active={activeItem === 'best'}
          onClick={this.handleItemClick}
          >
          <NavLink to='/best'>
            <h3>Best Of</h3>
          </NavLink>
        </Menu.Item>
        <Menu.Item
          name='about'
          active={activeItem === 'about'}
          onClick={this.handleItemClick}
          >
          <NavLink to='/about'>
            <h3>About Us</h3>
          </NavLink>
        </Menu.Item>
      </Menu>
    )
  }
}

export default Navbar